import {
  APILoadingStatus,
  MapCameraProps,
  useApiLoadingStatus,
  Map,
} from '@vis.gl/react-google-maps';
import React, { useEffect, useState } from 'react';
import OnboardingStepMarkers from './components/OnboardingStepMarkers';
import DashboardTutorial from '@src/shared/components/Tutorial/tutorials/DashboardTutorial';
import { useTutorialActions } from '@src/shared/context/tutorial';
import { TUTORIAL_DASHBOARD } from '@src/shared/components/Tutorial/TutorialsContainer';
import { useOnboardingStore } from '@src/shared/store/onboarding/onboarding-store';
import DashboardScreenRouter from '../DashboardScreenRouter';
import useBoundDashboardStore from '../../store/dashboardGlobalStore';
import { CourierReturnStatusType, CourierVehicleType, OrderStatus } from '../../models/model-enum';
import dayjs from 'dayjs';
import useOnboardingTracking from './tracking/use-onboarding-tracking';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';

export const DashboardOnboarding = () => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const status = useApiLoadingStatus();
  const { activeStep, addStep } = useOnboardingStore();
  const { startTutorial } = useTutorialActions();
  const { setCouriersList, setCourierStatus, setCourierEta, setOrdersList } =
    useBoundDashboardStore();
  const { trackStepInitialize } = useOnboardingTracking();
  const { isResolutionMobile, isTablet } = useDeviceDetect();

  const mockCourierList = [
    {
      id: 'mock-courier-1',
      firstName: 'Jane',
      lastName: 'Doe',
      isGuest: false,
      vehicleType: CourierVehicleType.Bike,
      timestamp: new Date().getTime(),
    },
    {
      id: 'mock-courier-2',
      firstName: 'John',
      lastName: 'Smith',
      isGuest: false,
      vehicleType: CourierVehicleType.Bike,
      timestamp: new Date().getTime(),
    },
    {
      id: 'mock-courier-3',
      firstName: 'Jean',
      lastName: 'Dupont',
      isGuest: false,
      vehicleType: CourierVehicleType.Bike,
      timestamp: new Date().getTime(),
    },
  ];

  const mockCourierStatuses = [
    {
      id: 'mock-courier-1',
      timestamp: new Date().getTime(),
      status: CourierReturnStatusType.Returning,
    },
    {
      id: 'mock-courier-2',
      timestamp: new Date().getTime(),
      status: OrderStatus.InDelivery,
    },
    {
      id: 'mock-courier-3',
      timestamp: new Date().getTime(),
      status: OrderStatus.Assigned,
    },
  ];

  const mockOrderList = [
    {
      customer: {
        lastName: 'Customer Name',
        address: {
          street: 'Example Street',
          streetNumber: '01',
          postcode: '00000',
          city: 'Example City',
          apartmentNumber: '01',
          floor: '01',
        },
      },
      courier: {
        firstName: 'John',
        lastName: 'Doe',
        id: 'test-order-courier-id-1',
        isGuest: false,
        timestamp: new Date().getTime(),
        vehicleType: CourierVehicleType.Bike,
      },
      expectedDeliveryTime: '',
      hasAlcohol: false,
      hash: 'sample-hash',
      items: [],
      location: { latitude: 0, longitude: 0 },
      orderDate: '',
      platform: '',
      reference: 'sample-ref-1',
      status: OrderStatus.Unassigned,
      timestamp: new Date().getTime(),
      updateDate: '',
      uuid: 'f3431bc6-f5bd-58c8-8802-5dd11524d87e',
      comments: '',
    },
  ];
  useEffect(() => {
    if (status === APILoadingStatus.LOADING) {
      return;
    }
    if (status === APILoadingStatus.LOADED) {
      setIsMapLoaded(true);
      return;
    }
    if (status === APILoadingStatus.AUTH_FAILURE) {
      console.log('GOOGLE MAP AUTHENTICATION FAILED');
      return;
    }
    if (status === APILoadingStatus.FAILED) {
      console.log('GOOGLE MAP FAILED TO LOAD');
      return;
    }
    if (status === APILoadingStatus.NOT_LOADED) {
      console.log('MAP NOT LAODED');
      return;
    }
  }, [status]);

  useEffect(() => {
    setOrdersList(mockOrderList);
    setCouriersList(mockCourierList);
    setCourierStatus(mockCourierStatuses as any);
    setCourierEta([
      {
        eta: dayjs().add(6, 'minute').valueOf().toString(),
        id: 'mock-courier-1',
        timestamp: dayjs().valueOf(),
      },
    ]);
    startTutorial(TUTORIAL_DASHBOARD);
  }, []);

  const INITIAL_CAMERA: MapCameraProps = {
    center: !isResolutionMobile
      ? {
          lat: 52.49402005714219,
          lng: 13.430915,
        }
      : {
          lat: 52.49402005714219,
          lng: 13.435610229544212,
        },
    zoom: 16,
  };

  return (
    <>
      {isMapLoaded ? (
        <>
          <Map
            gestureHandling={'none'}
            disableDefaultUI={true}
            defaultCenter={INITIAL_CAMERA.center}
            defaultZoom={INITIAL_CAMERA.zoom}
            zoomControl={false}
            reuseMaps={true}
            mapId={'4290118927440e94'}
          ></Map>
          <DashboardScreenRouter />
          <OnboardingStepMarkers stepNumber={activeStep} />
          <DashboardTutorial
            onStepChange={(currentStep) => {
              trackStepInitialize(currentStep);
              addStep(currentStep);
            }}
          />
        </>
      ) : null}
    </>
  );
};

export default DashboardOnboarding;
